<template>
  <v-container>
    <app-city-header :payload="payload"> </app-city-header>

    <v-row>
      <v-col sm="3">
        {{ payload.titulo }}
      </v-col>

      <v-col sm="2" offset-sm="7" class="text-right">
        <v-btn
          v-if="isAdmin || user.usuarioId === payload.usuarioId"
          outlined
          color="primary"
          class="ml-3"
          @click="update(payload)"
        >
          <span>Atualizar</span>
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col sm="3">
        <v-text-field
          v-model="payload.inicioString"
          v-mascara="'##/##/#### ##:##'"
          label="Data de Início"
          placeholder="00/00/0000 00:00"
          :disabled="
            payload.statusRelatorioId === 2 || payload.statusRelatorioId === 4
          "
        ></v-text-field>
      </v-col>

      <v-col sm="3">
        <v-text-field
          v-model="payload.fimString"
          v-mascara="'##/##/#### ##:##'"
          label="Data de Término"
          placeholder="00/00/0000 00:00"
          :disabled="
            payload.statusRelatorioId === 2 || payload.statusRelatorioId === 4
          "
        ></v-text-field>
      </v-col>

      <v-col sm="2">
        <v-text-field
          v-model="payload.horas"
          label="Horas Correspondentes"
          placeholder="0"
          type="number"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-tabs vertical>
        <v-tab>
          <v-icon left>mdi-file-chart</v-icon>
          Relatório
        </v-tab>

        <v-tab>
          <v-icon left>mdi-attachment</v-icon>
          Anexos
        </v-tab>

        <v-tab-item>
          <v-col>
            <v-textarea
              v-model="payload.descricao"
              :readonly="
                payload.statusRelatorioId === 2 ||
                payload.statusRelatorioId === 4
              "
            ></v-textarea>
          </v-col>
        </v-tab-item>

        <v-tab-item>
          <v-col
            v-if="
              payload.statusRelatorioId !== 2 && payload.statusRelatorioId !== 4
            "
          >
            <template>
              <v-file-input
                multiple
                label="File input"
                v-model="payload.arquivos"
              >
              </v-file-input>
            </template>
          </v-col>
          <v-data-table
            :headers="headersAnexos"
            :items="payload.anexos"
            class="elevation-1"
            hide-default-footer
            disable-pagination
          >
            <template v-slot:item.download="{ item }">
              <v-btn
                outlined
                color="primary"
                class="ml-3"
                @click="downloadAnexo(item)"
              >
                <span>Download</span>
              </v-btn>
            </template>

            <template slot="no-data">
              <span> Nenhum anexo retornado </span>
            </template>
          </v-data-table>
        </v-tab-item>
      </v-tabs>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { administrativeReportAPI } from "@/modules/administrative-report";
import { AppCityHeader } from "@/modules/city";

export default {
  components: {
    AppCityHeader,
  },
  data() {
    return {
      payload: {
        arquivos: [],
      },
      headersAnexos: [
        { text: "Nome", value: "nome" },
        { text: "", value: "download" },
      ],
    };
  },
  methods: {
    ...mapActions([
      "setLoading",
      "setConsultorCondutorMunicipio",
      "setConsultorEspecialistaMunicipio",
      "setAnalistaMunicipio",
      "setADMunicipio",
    ]),
    get() {
      this.setLoading(true);
      administrativeReportAPI
        .get(this.$route.params.relatorio)
        .then((resp) => {
          this.payload = resp.data;
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter relatório");
        });
    },
    downloadAnexo(evidencia) {
      administrativeReportAPI
        .downloadAnexo(evidencia.relatorioAdministrativoAnexoId)
        .then((resp) => {
          let blob = new Blob([resp.data], {
            type: resp.headers["content-type"],
          });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = evidencia.nome;
          link.click();

          this.setLoading(false);
        })
        .catch((resp) => {
          console.log("resp: ", resp);
          this.setLoading(false);
          this.$notification.error("Erro ao obter anexo");
        });
    },
    update(relatorio) {
      this.setLoading(true);
      let formData = new FormData();

      if (this.payload.arquivos) {
        for (let i = 0; i < this.payload.arquivos.length; i++) {
          formData.append("arquivos", this.payload.arquivos[i]);
        }
      }

      formData.append("descricao", this.payload.descricao);
      formData.append("municipioId", this.payload.municipioId);
      formData.append("usuarioId", this.payload.usuarioId);
      formData.append(
        "relatorioAdministrativoId",
        this.payload.relatorioAdministrativoId
      );
      formData.append("statusRelatorioId", this.payload.statusRelatorioId);
      formData.append("titulo", this.payload.titulo);
      formData.append("inicioString", this.payload.inicioString);
      formData.append("fimString", this.payload.fimString);
      formData.append("criacaoString", this.payload.criacaoString);
      formData.append("horas", this.payload.horas);
      if (this.payload.motivoRejeicao) {
        formData.append("motivoRejeicao", this.payload.motivoRejeicao);
      }

      administrativeReportAPI
        .update(formData)
        .then((resp) => {
          this.setLoading(false);
          this.$notification.success("Relatório Administrativo Atualizado");
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error(
            "Erro ao atualizar relatório administrativo"
          );
        });
    },
  },
  mounted() {
    this.get();
    this.setConsultorCondutorMunicipio(this.$route.params.id);
    this.setConsultorEspecialistaMunicipio(this.$route.params.id);
    this.setAnalistaMunicipio(this.$route.params.id);
    this.setADMunicipio(this.$route.params.id);
  },
  computed: {
    ...mapGetters([
      "isAdmin",
      "isConsultorCondutorMunicipio",
      "isConsultorEspecialistaMunicipio",
      "isADMunicipio",
      "isAuthenticated",
      "user",
    ]),
  },
};
</script>
